import {
    PutEffect,
    PutEffectDescriptor,
    SelectEffect,
    SimpleEffect,
    put,
    select,
    takeEvery
} from "redux-saga/effects";
import axios from "axios";
import { RootState } from "../reducers";
import { curbLinksReceived } from "../actions";
import {
    CurbLinksReceived,
    GET_CURB_LINKS,
    GetCurbLinks,
    POST_FEEDBACK_DATA,
    POST_SEGMENT_FEEDBACK_DATA,
    PostFeedbackData,
    PostSegmentFeedbackData
} from "../actions/Map/types";
import { getRequest, showError } from "../components/commonUtilities";
import { decrypt } from "../Utilities/decryption";
import { isPathPublicViewer } from "../Utilities/generalUtilities";
import { CurbLinksInterface } from "../components/curb/map/deckgl/interfaces";

const isGeoserverEnabledSelector = (state: RootState) => state.globals.isGeoserverEnabled;

function* getCurbLinks(
    action: GetCurbLinks
): Generator<
    | Promise<CurbLinksReceived["payload"]>
    | CurbLinksReceived
    | SelectEffect
    | PutEffect<{ payload: CurbLinksReceived["payload"]; type: string }>,
    void,
    CurbLinksReceived["payload"]["curbLinks"]
> {
    const isGeoserverEnabled = yield select(isGeoserverEnabledSelector);
    const isGeoserverEnabledValue = isGeoserverEnabled ? "v2/" : "";

    const getPath = isPathPublicViewer();
    try {
        let json = getPath
            ? yield getRequest("/api/alllinks/get_links_public_viewer/", action.payload.params)
            : yield getRequest(
                  `/api/${isGeoserverEnabledValue}alllinks/GetLinksInBox/`,
                  action.payload.params
              );

        json = decrypt(json);

        if (action.payload.nextProcess) {
            action.payload.nextProcess();
        }

        yield put(curbLinksReceived({ curbLinks: json }));
    } catch (error) {
        showError(error);
    }
}

export function* getCurbLinksSaga() {
    yield takeEvery(GET_CURB_LINKS, getCurbLinks);
}

function* postFeedbackData(action: PostFeedbackData) {
    try {
        const url = action.payload.contactSupport ? "/api/support/" : "/api/feedback/";
        yield axios.post(url, action.payload.data).then((response) => response.data);

        if (action.payload.afterProcess) {
            action.payload.afterProcess();
        }
    } catch (e) {
        showError(e);
    }
}

export function* postFeedbackDataSaga() {
    yield takeEvery(POST_FEEDBACK_DATA, postFeedbackData);
}

function* postSegmentFeedbackData(action: PostSegmentFeedbackData) {
    try {
        yield axios
            .post("/api/segment-feedback/", action.payload.data)
            .then((response) => response.data);
        if (action.payload.afterProcess) {
            action.payload.afterProcess();
        }
    } catch (e) {
        showError(e);
    }
}

export function* postSegmentFeedbackDataSaga() {
    yield takeEvery(POST_SEGMENT_FEEDBACK_DATA, postSegmentFeedbackData);
}
